import { obterHtml } from './v2/api';
import { avisarErro } from './v2/aviso';
import { comBotao } from './v2/botao';
import { textos } from './v2/config';

// Editais v2 (Vagas/EditaisV2): as abas trocam o painel sem recarregar (o link de cada aba é a página daquela aba, para quem está
// sem JS) e o "Carregar mais" de cada aba traz a próxima página dela pelo ?parcial=lista da mesma action, sem a /api.
const raiz = document.getElementById('editais');
const cliqueComum = e => e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey;

if (raiz) {
    const T = textos(raiz);
    const abas = [...raiz.querySelectorAll('[role="tab"]')];
    // O tabindex móvel do ARIA só com JS: sem ele, as abas são links comuns, alcançáveis pelo Tab.
    abas.forEach(a => { a.tabIndex = a.getAttribute('aria-selected') === 'true' ? 0 : -1; });
    // Aberta numa ?pagina=N, os painéis vieram todos na página N: a aba abre a 1ª página dela, pelo link.
    const naPrimeira = (+raiz.dataset.pagina || 1) === 1;

    // O endereço passa a ser o da aba (recarregar ou voltar abre nela), sem entrada nova no histórico.
    const selecionar = (aba, focar = false) => {
        abas.forEach(a => {
            const atual = a === aba;
            a.setAttribute('aria-selected', String(atual));
            a.tabIndex = atual ? 0 : -1;
            const painel = document.getElementById(a.getAttribute('aria-controls'));
            if (painel) {
                painel.hidden = !atual;
            }
        });
        if (focar) {
            aba.focus();
        }
        history.replaceState(history.state, '', aba.getAttribute('href'));
    };

    const carregarMais = link => comBotao(link, async () => {
        let html;
        try {
            html = await obterHtml(`${link.getAttribute('href')}&parcial=lista`);
        } catch {
            avisarErro(T.erro);
            return;
        }
        const modelo = document.createElement('template');
        modelo.innerHTML = html;
        const lista = raiz.querySelector(`[data-lista="${link.dataset.mais}"]`);
        const novos = [...modelo.content.querySelectorAll('[data-lista] > li')];
        lista?.append(...novos);
        // A próxima página desta aba; na última, o botão sai.
        const proximo = modelo.content.querySelector('[data-mais]')?.getAttribute('href');
        if (proximo) {
            link.setAttribute('href', proximo);
        } else {
            // O botão que some com o foco o mandaria para depois da lista: o foco vai para o 1º edital que chegou.
            const comFoco = document.activeElement === link;
            link.removeAttribute('href');
            link.hidden = true;
            if (comFoco) {
                novos[0]?.querySelector('a')?.focus();
            }
        }
    });

    raiz.addEventListener('click', e => {
        const aba = e.target.closest('[role="tab"]');
        if (aba && cliqueComum(e)) {
            if (!naPrimeira) {
                return;
            }
            e.preventDefault();
            selecionar(aba);
            return;
        }
        const mais = e.target.closest('[data-mais]');
        if (mais && mais.getAttribute('href') && cliqueComum(e)) {
            e.preventDefault();
            carregarMais(mais);
        }
    });

    // Logo que não carrega (removida do Blob, endereço velho) vira as iniciais da empresa, como o card sem logo. O erro pode ter
    // acontecido antes deste script (defer): as que já falharam são trocadas aqui, e as do "Carregar mais" pelo evento.
    const trocarPorIniciais = img => {
        const caixa = img.closest('[data-iniciais]');
        if (caixa) {
            caixa.textContent = caixa.dataset.iniciais;
        }
    };
    raiz.querySelectorAll('[data-iniciais] img').forEach(img => {
        if (img.complete && img.naturalWidth === 0) {
            trocarPorIniciais(img);
        }
    });
    raiz.addEventListener('error', e => {
        if (e.target instanceof HTMLImageElement) {
            trocarPorIniciais(e.target);
        }
    }, true);

    // Padrão de abas do ARIA: as setas, Home e End andam entre as abas e já mostram o painel.
    raiz.addEventListener('keydown', e => {
        const aba = e.target.closest('[role="tab"]');
        if (!aba) {
            return;
        }
        const i = abas.indexOf(aba);
        const destino = e.key === 'ArrowRight' ? abas[(i + 1) % abas.length]
            : e.key === 'ArrowLeft' ? abas[(i - 1 + abas.length) % abas.length]
                : e.key === 'Home' ? abas[0]
                    : e.key === 'End' ? abas[abas.length - 1]
                        : null;
        if (destino) {
            e.preventDefault();
            if (!naPrimeira) {
                location.assign(destino.href);
                return;
            }
            selecionar(destino, true);
        }
    });
}
